/**
 * @descripttion: 店铺状态
 */

export const Shop_Status = {
  1: '营业中',
  2: '休息中',
  3: '超出配送范围',
  4: '暂停配送',
  5: '休息中',
}

/**
 * 店铺状态枚举
 */
export const SHOP_STATUS_ENUM = {
  /**
   * 营业中
   */
  1: '1',
  /**
   * 休息中
   */
  2: '2',
  /**
   * 超出配送范围
   */
  3: '3',
  /**
   * 暂停配送
   */
  4: '4',
  /**
   * 休息中
   */
  5: '5',
}

// 商家自配送
export const STORE_DELIVERY = 2

export const SEO_CHANNEL = 19

export const GOOGLE_MAP_CHANNEL = 10

/**
 * 商家各种原因关闭店铺
 */
export const STORE_CLOSE_STATUS = '101'
